import type { HttpClient } from '@wix/http-client'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import {
  isEditor3,
  type AppApi,
  type EDITOR_TYPE,
} from '@wix/wix-data-client-common'
import type { DynamicPageUrlCounter } from './types'
import { createDynamicPageUrlCounter } from './dynamicPageUrlCounter'

export const setUpDynamicPageUrlCounter = ({
  editorSdkProxy,
  httpClient,
  finalAppApiPromise,
  editorType,
}: {
  editorSdkProxy: EditorSDK
  httpClient: HttpClient
  finalAppApiPromise: Promise<AppApi>
  editorType: EDITOR_TYPE
}): DynamicPageUrlCounter => {
  const counter = createDynamicPageUrlCounter({
    editorSdkProxy,
    httpClient,
    getGridAppId: async () => {
      const appApi = await finalAppApiPromise
      return appApi.getGridAppId()
    },
  })

  finalAppApiPromise.then(appApi => {
    const resetCounter = (pageRefs?: PageRef[]) => {
      if (pageRefs) {
        const eager = isEditor3(editorType)
        counter.reset(pageRefs, eager)
      } else {
        counter.resetAll()
      }

      appApi.emit('dynamicPageUrlCountsChanged')
    }

    appApi.addListener('contentManagerClosed', () => {
      resetCounter()
    })
    appApi.addListener('routerDatasetFilterChanged', (pageRef: PageRef) => {
      resetCounter([pageRef])
    })
    appApi.addListener('dynamicPageUrlChanged', (pageRef: PageRef) => {
      resetCounter([pageRef])
    })
    appApi.addListener('itemPageLinksGenerated', (pageRefs: PageRef[]) => {
      resetCounter(pageRefs)
    })
    appApi.addListener('routersChanged', (pageRefs: PageRef[]) => {
      resetCounter(pageRefs)
    })
  })

  return counter
}
